var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
var SvgStar = function SvgStar(props) {
  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    fill: "none",
    viewBox: "0 0 16 15"
  }, props), _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m8 12.375-3.477 2.11c-.625.39-1.406-.196-1.21-.9l.898-3.944-3.047-2.657c-.547-.468-.273-1.406.469-1.445l4.023-.351L7.22 1.477a.862.862 0 0 1 1.562 0l1.563 3.71 4.023.352c.742.078 1.016.977.469 1.445l-3.047 2.657.899 3.945c.195.703-.586 1.289-1.211.898z"
  })));
};
export default SvgStar;